import React from "react";
import { FaGear } from "react-icons/fa6";
import { TbLogout2 } from "react-icons/tb";
import axios from "../lib/axios";
import { useDispatch, useSelector } from "react-redux";
import { setPermissions, setToken, setUser } from "../redux/features/authSlice";
import { Link, useNavigate } from "react-router-dom";
import Setting from "./navitems/Setting";
import NavPurchase from "./purchases/NavPurchase";
import CreatePurchase from "./purchases/CreatePurchase";
import Create from "./purchases/payments/Create";
import NavMaterial from "./materials/NavMaterial";
import CreateMaterial from "./materials/CreateMaterial";
import NavPreparation from "./preparations/NavPreparation";
import DistributeCreate from "./distributes/Create";
import NavSale from "./sales/NavSale";
import CreateSale from "./sales/CreateSale";
import NavExpense from "./expenses/NavExpense";
import PCreate from "./sales/payments/Create";
import ReportPurchase from "./purchases/ReportPurchase";
import ReportPurchasePayment from "./purchases/payments/ReportPurchasePayment";
import ReportSale from "./sales/ReportSale";
import ReportSalePayment from "./sales/payments/ReportSalePayment";
import ReportExpense from "./expenses/ReportExpense";
import ReportMaterial from "./materials/ReportMaterial";
import ReportDistribute from "./distributes/ReportDistribute";
import NavQuote from "./quotes/NavQuote";
import CreateQuote from "./quotes/CreateQuote";
import GeneralReport from "./reports/GeneralReport";
import NavAccounting from "./accounting/NavAccounting";
import BalanceSheet from "./accounting/BalanceSheet";
import ProfitAndLoss from "./accounting/ProfitAndLoss";
import NavProduct from "./products/NavProduct";
import ReportProduct from "./products/ReportProduct";
import ReportTransaction from "./accounts/transactions/ReportTransaction";
import NavLoan from "./loans/NavLoan";
import ReportEquity from "./equities/ReportEquity";
import ReportDeposit from "./deposits/ReportDeposit";
import ReportLoan from "./loans/ReportLoan";

function Nav() {
  const permissions = useSelector((state) => state.auth.permissions);
  const purchaseCreateForm = useSelector((state) => state.purchase.createForm);
  const purchaseReportForm = useSelector((state) => state.purchase.report);
  const purchasePaymentReportForm = useSelector(
    (state) => state.purchase.paymentReport
  );
  const saleCreateForm = useSelector((state) => state.sale.createForm);
  const saleReportForm = useSelector((state) => state.sale.report);
  const salePaymentReportForm = useSelector(
    (state) => state.sale.paymentReport
  );

  const quoteCreateForm = useSelector((state) => state.quote.createForm);

  const purchasePaymentCreateForm = useSelector(
    (state) => state.purchase.paymentCreateForm
  );
  const salePaymentCreateForm = useSelector(
    (state) => state.sale.paymentCreateForm
  );
  const materialCreatForm = useSelector((state) => state.material.createForm);
  const preparationCreateForm = useSelector(
    (state) => state.preparation.createForm
  );
  const distributeCreateForm = useSelector(
    (state) => state.distribute.createForm
  );

  const expenseReportForm = useSelector((state) => state.expense.report);
  const materialReportForm = useSelector((state) => state.material.report);
  const distributeReportForm = useSelector((state) => state.distribute.report);
  const productReport = useSelector((state) => state.product.report);
  const transactionReport = useSelector((state) => state.transaction.report);
  const equityReport = useSelector((state) => state.equity.report);
  const depositReport = useSelector((state) => state.deposit.report);
  const loanReport = useSelector((state) => state.loan.report);
  const generalReport = useSelector((state) => state.report.reportForm);
  const balanceSheetForm = useSelector(
    (state) => state.accounting.balanceSheetForm
  );
  const profitAndLossForm = useSelector(
    (state) => state.accounting.profitAndLossForm
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = (e) => {
    e.preventDefault();

    axios
      .post("/api/logout")
      .then((data) => {
        clearCatch();
      })
      .catch((error) => {
        console.log(error);
        clearCatch();
      });
  };

  const clearCatch = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("authToken");
    localStorage.removeItem("permissions");
    dispatch(setUser(null));
    dispatch(setToken(null));
    dispatch(setPermissions([]));
    navigate("/login");
  };
  return (
    <div className="flex flex-col lg:flex-row lg:justify-between bg-gray-800 text-gray-300 px-4 lg:px-8 py-2">
      <div className="lg:flex lg:gap-4 lg:items-center">
        <Link to="/" className="hover:text-white font-bold p-1">
          داشبورد
        </Link>
        <NavPurchase />
        {permissions["view materials"] && <NavMaterial />}
        <NavPreparation />
        {permissions["view products"] && <NavProduct />}
        <NavSale />
        <NavAccounting />

        {permissions["view expenses"] && <NavExpense />}
        <NavQuote />
        <NavLoan />
      </div>
      <div className="flex lg:gap-4 lg:items-center">
        <Setting />

        <button
          onClick={handleLogout}
          className="bg-gray-100 hover:bg-gray-400 p-2 rounded-md"
        >
          <TbLogout2 className="text-gray-800" size={18} />
        </button>
      </div>
      {materialCreatForm && <CreateMaterial />}
      {purchaseCreateForm && <CreatePurchase />}
      {saleCreateForm && <CreateSale />}
      {purchasePaymentCreateForm && <Create />}
      {salePaymentCreateForm && <PCreate />}
      {quoteCreateForm && <CreateQuote />}

      {distributeCreateForm && <DistributeCreate />}
      {purchaseReportForm && <ReportPurchase />}
      {purchasePaymentReportForm && <ReportPurchasePayment />}
      {saleReportForm && <ReportSale />}
      {salePaymentReportForm && <ReportSalePayment />}

      {expenseReportForm && <ReportExpense />}
      {materialReportForm && <ReportMaterial />}
      {distributeReportForm && <ReportDistribute />}
      {generalReport && <GeneralReport />}
      {balanceSheetForm && <BalanceSheet />}
      {profitAndLossForm && <ProfitAndLoss />}
      {productReport && <ReportProduct />}
      {transactionReport && <ReportTransaction />}
      {equityReport && <ReportEquity />}
      {depositReport && <ReportDeposit />}
      {loanReport && <ReportLoan />}
    </div>
  );
}

export default Nav;
